/* TÖSTI: lyse tekst-med-billede-blokke (fx ambassadører, hver anden) => brun baggrund + sandfarvet tekst. Rene hvide blokke => sandfarvet baggrund i stedet for hvid. Hver blok klassificeres kun ÉN gang (via tosti-brown-block/tosti-sand-block), så den sandfarvede baggrund vi selv sætter ikke fejlagtigt bliver læst som 'lys/grå' og konverteret videre til brun. */
(function(){
  'use strict';
  var BROWN = 'var(--tosti-brown,#2f231b)';
  var st = document.createElement('style');
  st.textContent = '.tosti-brown-block *:not(svg):not(path):not(img){color:var(--tosti-sand,#F7F2E3) !important}' +
    '.tosti-brown-block a{text-decoration-color:var(--tosti-sand,#F7F2E3)}' +
    '.tosti-sand-block{background-color:var(--tosti-sand,#F7F2E3) !important}';
  (document.head || document.documentElement).appendChild(st);
  function paint(g){
    if(g.style.getPropertyValue('background-color') !== BROWN || g.style.getPropertyPriority('background-color') !== 'important'){
      g.style.setProperty('background-color', BROWN, 'important');
    }
  }
  function run(){
    var list = document.querySelectorAll('.featured-content .grid');
    for(var i = 0; i < list.length; i++){
      var g = list[i];
      if(!/homepage-(text-with-image|image-with-text)/.test(g.className)) continue;
      if(g.classList.contains('tosti-brown-block')){ paint(g); continue; }
      if(g.classList.contains('tosti-sand-block')) continue;
      var m = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(getComputedStyle(g).backgroundColor || '');
      if(!m) continue;
      var r = +m[1], gg = +m[2], b = +m[3];
      if(r === 255 && gg === 255 && b === 255){ g.classList.add('tosti-sand-block'); continue; }
      /* lys, men ikke hvid = de tidligere grå/sand-blokke */
      if(r >= 225 && gg >= 215 && b >= 195){ g.classList.add('tosti-brown-block'); paint(g); }
    }
  }
  var n = 0, iv = setInterval(function(){ run(); if(++n > 120) clearInterval(iv); }, 250);
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
